import CampaignIcon from '@mui/icons-material/Campaign'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'

/**
 * « Mes campagnes » — page TRANSVERSE (radio + PLV) sous « Ma pharmacie », sur le modèle
 * de la page Facturation : un tableau unique des programmes des deux modules, chips de
 * filtre « Toutes / Ma radio / Ma PLV », detail panel par module. Remplace les deux
 * entrées de menu par module (les anciennes pages restent servies pour les deep-links).
 */
export const routeFrontOfficeMyCampaigns = [
  {
    route: 'MyCampaigns',
    text: 'Mes campagnes',
    t: 'routes.frontoffice.all.myCampaigns',
    icon: CampaignIcon,
    href: '/frontoffice/group/campaigns',
    menuHeader: true,
    // Menu v2 : rattache a la section commune « Ma pharmacie » (dedoublonne cross-entites).
    menuGroup: MENU_GROUPS.PHARMACY,
    position: 35,
  },
  {
    // Detail d'UNE campagne : repartition par enveloppe (Generique / Biosimilaire) et
    // detail de la dotation. Hors menu — on y entre par la ligne du tableau « Mes
    // campagnes ». Monte par les memes fichiers de role que l'entree ci-dessus, les
    // `entity` / `roles` sont poses par leur `.map()` final.
    route: 'MyCampaignDetail',
    text: 'Ma campagne',
    t: 'components.myCampaigns.axis.title',
    icon: CampaignIcon,
    href: '/frontoffice/group/campaigns/[campaignId]',
    menuHeader: false,
    position: 36,
  },
]
